import { proxy, useSnapshot } from 'valtio';

import devtoolsApi from '#/dev/devtools';

export interface GeneralModalStore {
  isModalVisible: boolean;
  opts: ModalStateOpts;
}
export interface ModalStateOpts {
  /** Message text to be displayed in the modal */
  message: string;

  /** @optional Modal title to be shown in the modal */
  title?: string;

  /** @optional Text visible on the CTA button in the modal @default `t('button.ok')` */
  buttonLabel?: string;

  /** @optional A function to call when closing the modal box */
  onDismiss?: () => void;

  /** @optional A function to call when clicking on the modal button,
   * if it is not given, onDismiss will run on button click as well */
  onOk?: () => void;
}

const initialStore = {
  isModalVisible: false,
  opts: { message: '' },
};

export const generalModalStore = proxy<GeneralModalStore>(initialStore);

export const generalModalActions = {
  showModal(opts: ModalStateOpts) {
    generalModalStore.opts = opts;
    generalModalStore.isModalVisible = true;
  },
  hideModal() {
    generalModalStore.opts = initialStore.opts;
    generalModalStore.isModalVisible = false;
  },
  reset() {
    Object.keys(generalModalStore).forEach((key) => {
      generalModalStore[key] = initialStore[key];
    });
  },
};

export const useGeneralModalStore = () =>
  useSnapshot(generalModalStore) as GeneralModalStore;

devtoolsApi.setStore('generalModal', generalModalStore, generalModalActions);
